var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        t: "1583806459458",
        viewBox: "0 0 1053 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "2392",
        width: "23",
        height: "23"
      }
    },
    [
      _c("path", {
        attrs: {
          fill: "#fb4e44",
          d:
            "M488.218 225.024v231.388H13.517V270.664c0-29.236 23.117-52.619 52.08-52.619h216.336c-58.087-12.298-101.689-37.437-103.27-83.814-1.629-54.702 59.356-143.048 148.459-122.865 91.955 20.926 156.196 92.877 205.384 154.486C582.17 102.958 652.524 22.016 748.529 9.232 828.733-0.989 895.032 79.958 886.502 133.37c-7.321 46.807-51.66 72.315-108.272 84.618h213.596c28.964 0 52.086 23.43 52.086 52.618V456.3H569.16l-0.999-233.836M336.916 59.832c-44.39-17.735-70.405 1.28-89.103 32.482-10.163 17.628-21.12 41.113-4.895 58.316 42.706 44.411 159.826 41.114 238.403 32.855-37.023-46.755-82.575-99-144.405-123.653zM822.2 150.313c30.495-39.465-29.281-121.692-93.527-91.28C667.218 88.219 622.88 135.88 584.7 182.744c32.911 2.929 66.242 3.676 99.261 2.074 40.238-1.705 114.704-4.526 138.24-34.51z m-330.716 861.645H104.571c-26.01 0-47.186-21.3-47.186-48.036V493.855h434.15v518.103h-0.05z m508.508-48.092c0 26.731-21.12 48.035-47.186 48.035H565.95V493.798h434.043v470.068z",
          "p-id": "2393"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ddbeeb5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddbeeb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Gift.vue
// module id = eU0C
// module chunks = 15